<template>
  <div class="nav-bar">
    <div class="nav-area yxj-flex">
      <i class="el-icon-s-home home-icon"></i>
      <el-breadcrumb class="app-breadcrumb" separator="/">
        <transition-group name="breadcrumb">
          <el-breadcrumb-item v-for="(item, index) in pathList" :key="item.path">
            <span v-if="index === pathList.length - 1" class="no-link">{{ item.meta.title }}</span>
            <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
          </el-breadcrumb-item>
        </transition-group>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NavBar',
  data() {
    return {
      pathList: [],
    };
  },
  computed: {
    ...mapGetters({
      pathLimits: 'pathLimits',
      isCollapse: 'isCollapse',
    }),
  },
  watch: {
    $route() {
      // 监听路由变化
      this.getList();
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      // console.log(this.$route);
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title);
      const route = this.pathLimits.find((item) => { return item.path === this.$route.path; });
      if (route) {
        matched.splice(1, 0, {
          path: route.fromPath,
          meta: {
            title: route.fromTitle
          }
        });
      }
      const first = matched[0];
      if (!this.isHome(first)) {
        matched = [{ path: '/home', meta: { title: '首页' } }].concat(matched);
      } else {
        matched = [{ path: '/home', meta: { title: '首页' } }];
      }
      this.pathList = matched;
    },
    isHome(first) {
      if (first.path === '/home') {
        return true;
      } else {
        return false;
      }
    },
    handleLink(item) {
      if (item.path === '/mmCase/researchAdmin/view') {
        this.$router.push({ path: item.path, query: { id: this.$route.query.id } });
        return;
      }
      if (item.redirect) {
        this.$router.push({ path: item.redirect });
      } else {
        this.$router.push({ path: item.path });
      }
    },
  },
};
</script>

<style lang="less" scoped>
  .nav-bar {
    height: 40px;
    line-height: 40px;
    padding: 0 12px;
    font-size: 12px;
    background: #f8f8f8;
  }
  .nav-area {
    height: 40px;
  }
  .home-icon {
    font-size: 18px;
    color: #999;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/layout/NavBar.vue